
import _ from 'lodash'
import { cmnMsStr } from '~/mixin/ms/msMixin'

import DaisoDialog from '~/components/common/modal/DaisoDialog.vue'
import StoreUnitCard from '~/components/common/address/StoreUnitCard.vue'
import NoData from '~/components/common/template/NoData.vue'

export default {
  components: {
    NoData,
    DaisoDialog,
    StoreUnitCard,
  },
  mixins: [cmnMsStr],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    geolocationAgrYn: {
      type: String,
      default: 'N'
    },
    curLttd: {
      type: Number,
      default: 0.0
    },
    curLitd: {
      type: Number,
      default: 0.0
    },
  },
  data () {
    return {
      isPickup: true,
      state1: '',
      strList: [],
      totalCnt: 0,
      srchForm: {
        mbMngNo: this.$store.getters['session/getMbMngNo'],
        keyword: '',
        // srchBassPkupStrYn: 'Y',
        pkupYn: '',

        geolocationAgrYn: 'N',
        curLttd: 0.0,
        curLitd: 0.0,

        currentPage: 1,
        pageSize: 10

      },
      // 무한 스크롤
      bSrchKeyword: false,
      bLoadMore: false,
      bSrching: false,
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.selStr()
        this.srchForm.keyword = ''
      }
    },
    isPickup () {
      this.selStr()
    },
  },
  mounted () {
  },
  methods: {
    closePopup () {
      this.$emit('closePopup')
    },
    handleKeyEnter () {
      this.$refs.auto.close()
      this.selStr('Y', false)
    },
    addStore (item, idx) {
      this.$emit('pick-btn-click', item)
    },

    async selStr (srchYn, add) {
      this.srchForm.srchYn = srchYn

      if (srchYn === 'Y' && !this.srchForm.keyword) {
        return
      }

      this.bSrchKeyword = srchYn === 'Y'
      this.bSrching = true

      if (!add) {
        this.strList = []
        this.totalCnt = 0
        this.srchForm.currentPage = 1
        this.srchForm.pageSize = 10
      }
      this.srchForm.geolocationAgrYn = this.geolocationAgrYn
      this.srchForm.curLttd = this.curLttd
      this.srchForm.curLitd = this.curLitd
      this.srchForm.pkupYn = this.isPickup ? 'Y' : ''

      // 조회
      await this.$AxiosBuilder
        .data(this.srchForm)
        .build()
        .post('/ms/msg/selStr')
        .then((res) => {
          if (!this.isEmpty(res.data.data)) {
            this.startIndex = this.strList.length
            this.reloadSize = res.data.data.length
            this.totalCnt = res.data.data.length ? res.data.data[0].totalCnt : 0

            if (add) {
              this.strList = this.convertStatusStoreList(this.strList.concat(res.data.data))
            } else {
              this.strList = this.convertStatusStoreList(res.data.data)
            }

            this.bLoadMore = false
            this.bSrching = false
          }
        })
    },
    isEmpty (obj) {
      return isNaN(obj) ? _.isEmpty(obj) : false
    },
    strDtl (strCd) {
      this.$emit('strDtl', strCd)
    },
    getCurrentTime () {
      const now = new Date()
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      return `${hours}:${minutes}`
    },
    convertStatusStoreList (arr) {
      const currentTime = this.getCurrentTime()
      return _.map(arr, (item) => {
        if (!_.isEmpty(item.opngTime) && !_.isEmpty(item.clsngTime) && _.isEmpty(item.hldyDt)) {
          if (currentTime >= item.opngTime && currentTime <= item.clsngTime) {
            return { ...item, status: 'status' }
          } else {
            return { ...item, status: 'off' }
          }
        } else if (!_.isEmpty(item.hldyDt)) {
          return { ...item, status: 'close' }
        }
        return item
      })
    },
  }
}
